import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './prototype.css';
import './shell.css';
import { App } from './App.js';
import { applyTheme, currentTheme } from './lib/theme.js';

applyTheme(currentTheme());

const client = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false, staleTime: 10_000 },
  },
});

const el = document.getElementById('root');
if (!el) throw new Error('Chybí #root');

createRoot(el).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
